var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOrderIcon = function SvgOrderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20.561
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108596",
    d: "m.601.01 3.251.736a.553.553 0 0 1 .368.368l.491 2.392L20.6 5.041a.448.448 0 0 1 .368.613L18.514 13.2a.461.461 0 0 1-.429.307H6.797l.245 1.166H17.9c.613 0 .613 1.1 0 1.1H6.49a.448.448 0 0 1-.429-.368L3.239 1.728.356 1.115C-.257.931-.012-.112.601.015Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108597",
    d: "M8.944 16.329a2.117 2.117 0 1 1-2.147 2.086 2.121 2.121 0 0 1 2.147-2.086Zm0 1.043a1.075 1.075 0 0 0-1.043 1.043 1.043 1.043 0 0 0 2.086 0 1.075 1.075 0 0 0-1.043-1.043Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108598",
    d: "M15.569 16.329a2.117 2.117 0 1 1-2.086 2.086 2.083 2.083 0 0 1 2.086-2.086Zm0 1.043a1.022 1.022 0 0 0-.982 1.043.985.985 0 0 0 .982 1.043 1 1 0 0 0 1.043-1.043 1.034 1.034 0 0 0-1.043-1.043Z"
  })));
};
export default SvgOrderIcon;